/*
 * Randomize (for jQuery)
 * Taken from Stack Overflow
 * http://stackoverflow.com/questions/1533910/randomize-a-sequence-of-div-elements-with-jquery
 *
 * Provided by gruppler in 2012-08-01 post
 * Based on original code provided by Russ Cam in 2009-10-07 post
 *
 */

(function($) {

	$.fn.randomize = function(selector){
	    (selector ? this.find(selector) : this).parent().each(function(){
	        $(this).children(selector).sort(function(){
	            return Math.random() - 0.5;
	        }).detach().prependTo(this);
	    });

	    return this;
	};

})(jQuery);